import { createError } from '@common/neo.tax';
import { useContext } from 'react';

import { SredContextValue } from '../sred-context-provider.types';
import { SredContext } from '../SredContextProvider';

export const useSredContext = (): SredContextValue => {
  const { fiscalYear, fiscalYearId, isNowPastPeriodEndDate, period, periodName, product, sredTaxCreditId } =
    useContext(SredContext);
  if (
    !period ||
    !fiscalYearId ||
    !fiscalYear ||
    !periodName ||
    !product ||
    !sredTaxCreditId ||
    isNowPastPeriodEndDate === undefined
  ) {
    throw createError(
      'UseSredContextError',
      'useSredContext must be used within a SredContextProvider. Ensure this component is wrapped in <SredContextProvider>.',
    );
  }
  return { period, fiscalYearId, fiscalYear, periodName, product, isNowPastPeriodEndDate, sredTaxCreditId };
};
